import React, { useState, useRef } from "react";

import { Button, TextField, Paper, Typography, Grid } from "@mui/material";

const Chat = ({ currentUser }) => {
  const [messages] = useState([]);
  const [newMessage, setNewMessage] = useState("");

  const handleSendMessage = async () => {
    if (newMessage.trim() === "") return;

    // const message = {
    //   text: newMessage,
    //   createdAt: new Date().toISOString(),
    //   senderId: currentUser.uid,
    //   isAdmin: currentUser.isAdmin,
    // };

    // await messagesRef.add(message);
    setNewMessage("");
  };

  return (
    <Grid container component={Paper} sx={{ p: 2 }}>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <Typography variant="h6">Chat en vivo del evento</Typography>
      </Grid>
      <Grid item xs={12} sx={{ mb: 2 }}>
        {messages &&
          messages.map((message) => (
            <Typography
              key={message.id}
              sx={{
                color: message.isAdmin ? "red" : "inherit",
                fontWeight: message.isAdmin ? "bold" : "normal",
              }}
            >
              {message.senderId}: {message.text}
            </Typography>
          ))}
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Escribe un mensaje"
          variant="outlined"
          fullWidth
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          sx={{ mr: 1 }}
        />
        <Button variant="contained" onClick={handleSendMessage}>
          Enviar
        </Button>
      </Grid>
    </Grid>
  );
};

export default Chat;
